import React from 'react';
import { FormInstance } from 'antd/es/form/Form';
import { useTranslation } from 'react-i18next';

import { FormOnSubmitType, OpForm } from 'new-components/DLS/OpForm/OpForm';

import './ForgotPasswordForm.scss';

export interface ForgotPasswordInstance {
  email: string;
}

interface ForgotPasswordFormProps {
  form: FormInstance<ForgotPasswordInstance>;
  isSubmitting: boolean;
  initialValues?: { email: string | null };
  onSubmit: FormOnSubmitType;
}

/**
 * @component
 * @description Component that asks for the users email. Will show error if no allowed namespaces are found for the email.
 */
export const ForgotPasswordForm = ({
  form,
  initialValues,
  isSubmitting,
  onSubmit,
}: ForgotPasswordFormProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="forgot-password-information">
        <p>{t('Enter the email address you use with Avigilon Alta')}</p>
      </div>
      <OpForm
        className="email-form"
        form={form}
        initialValues={initialValues}
        onSubmit={onSubmit}
        defaultButtons={false}
        shouldWarnChangesBeforeUnload={false}
        hasError={false}
      >
        <OpForm.Input
          validateTrigger="onSubmit"
          rules={[
            { required: true, message: t('Email is required') },
            { type: 'email', message: t('Email is not valid') },
          ]}
          label={t('Email')}
          name="email"
        />
        <OpForm.Button
          className="email-form__submit"
          type="primary"
          loading={isSubmitting}
          onClick={() => {
            form.submit();
          }}
        >
          {t('Send password reset email')}
        </OpForm.Button>
      </OpForm>
    </div>
  );
};
